import { User } from 'modules/main/store/ducks/userEnvironment';

export function getUserType(user: User) {
  if (user) {
    if (user.permissions.includes('staff')) {
      return 'Staff';
    }

    if (user.orgs && user.orgs.length > 0) {
      let orgUserType = 'Org Admin';
      user.orgs.forEach((org) => {
        if (org.hasGradProgram) {
          orgUserType = 'Grad Admin';
        }
      });
      return orgUserType;
    }

    return 'Logged In User';
  }

  return 'Logged Out User';
}
